import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import { InfoItemProps } from '../../types/interfaces';
import CopyTextIcon from '../../components/CopyTextIcon/CopyTextIcon';
import { shortenAddress } from '../../utils';

interface ExtendedInfoItemProps extends InfoItemProps {
  showFullValue?: boolean;
}

const InfoItem = ({ label, value, icon, showFullValue = false }: ExtendedInfoItemProps) => {
  const [isExpanded, setIsExpanded] = useState(showFullValue);

  const handleValueClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <Typography variant='body1' color='grey' className='font-medium'>
        {label}
      </Typography>
      <div className='flex items-center gap-2'>
        <Typography 
          variant='body1' 
          color='black' 
          className='semibold cursor-pointer hover:text-blue-600'
          onClick={handleValueClick}
        >
          {isExpanded ? value : shortenAddress(value, 6, 6)}
        </Typography>
        {icon && (
          <CopyTextIcon textToCopy={value || ''}>
            <img src={icon} alt='Copy' />
          </CopyTextIcon>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
